import axios from 'axios'

function token () {
  return localStorage.getItem('api_token')
}

function url (apiBase) {
  return `${apiBase}/api/state`
}

export const statesApi = {
  list: (apiBase) => axios.get(`${url(apiBase)}?token=${token()}`).then((r) => r.data),
  show: (apiBase, id) => axios.get(`${url(apiBase)}/${id}?token=${token()}`).then((r) => r.data),
  create: (apiBase, payload) => axios.post(`${url(apiBase)}?token=${token()}`, payload).then((r) => r.data),
  update: (apiBase, id, payload) => axios.put(`${url(apiBase)}/${id}?token=${token()}`, payload).then((r) => r.data),
  remove: (apiBase, id) => axios.delete(`${url(apiBase)}/${id}?token=${token()}`).then((r) => r.data),
}

export default statesApi
